import React, { useEffect, useState } from "react";
import "./dhealnavbar.css";

import { FiMoon } from "react-icons/fi";
import { FaSearch } from "react-icons/fa";
import logoimg from "../assest/logo-removebg.png"
import headerlogoimage from "../assest/headerlogo.png"
import cmimageremovebg from "../assest/cm-removebg.png";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n";

const Dhealnavbar = ({ toggleTheme,  hideMainNavbar }) => {

  const { t } = useTranslation();
  const [langMenu, setLangMenu] = useState(false);
  const [selectedLang, setSelectedLang] = useState("ଓଡିଆ");

  const handleLanguageToggle = () => {
    setLangMenu(!langMenu);
  };

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    setSelectedLang(lng === "en" ? t("English") : t("Odia"));
    setLangMenu(false);
  };
  const changeFontSize = (action) => {
    let current = parseInt(localStorage.getItem("fontSize") || 100);

    if (action === "increase") current = Math.min(current + 10, 150);
    if (action === "decrease") current = Math.max(current - 10, 70);
    if (action === "reset") current = 100;

    document.documentElement.style.fontSize = current + "%";
    localStorage.setItem("fontSize", current);
  };
useEffect(() => {
  const saved = localStorage.getItem("fontSize") || 100;
  document.documentElement.style.fontSize = saved + "%";
}, []);

  return (
    <>
      <div>

        {/* TOP BLUE NAVBAR */}
        <div className="DhenkanalNavbarPage-topbar">
         <div className="DhenkanalNavbarPage-govt-wrapper">
    <img
      src={headerlogoimage}
      alt="Govt Logo"
      className="DhenkanalNavbarPage-govt-logo"
    />
    <span className="DhenkanalNavbarPage-govt">
      {t("govt")}
    </span>
  </div>

          <div className="DhenkanalNavbarPage-top-right">

            {/* Search Box */}
            <div className="DhenkanalNavbarPage-searchbox">
              <input type="text" placeholder={t("search")}
               />
              <button className="DhenkanalNavbarPage-search-btn">
                <FaSearch />
              </button>
            </div>

            {/* Icons */}
            <div className="DhenkanalNavbarPage-icons">
            <span onClick={toggleTheme} className="theme-icon-circle">
  <FiMoon size={14} />
</span>


              {/* UPDATED TO BUTTONS */}
              <button className="DhenkanalNavbarPage-fonticon" onClick={() => changeFontSize("decrease")}>A-</button>
              <button className="DhenkanalNavbarPage-fonticon" onClick={() => changeFontSize("reset")}>A</button>
              <button className="DhenkanalNavbarPage-fonticon" onClick={() => changeFontSize("increase")}>A+</button>


            </div>

            {/* Language Dropdown */}
            <div
              className="DhenkanalNavbarPage-lang-select"
              onClick={handleLanguageToggle}
            >
              {selectedLang}
              {langMenu && (
                <div className="DhenkanalNavbarPage-lang-menu">
                  <div onClick={() => handleLanguageChange("en")}>{t("English")}</div>
                  <div onClick={() => handleLanguageChange("or")}>{t("Odia")}</div>
                </div>
              )}
            </div>

          </div>
        </div>

        {/* MAIN NAVBAR */}
       {!hideMainNavbar && (
                <div className="DhenkanalNavbarPage-main">

          {/* LEFT – LOGO + TITLE */}
          <div className="DhenkanalNavbarPage-left">
            <img src={logoimg} alt="Logo" className="DhenkanalNavbarPage-logo" />
            <h2 className="DhenkanalNavbarPage-title">{t("title")}</h2>
          </div>

          <div className="DhenkanalNavbarPage-links"></div>

          <div className="DhenkanalNavbarPage-right">
            <div className="DhenkanalNavbarPage-cm-text">
              <span className="DhenkanalNavbarPage-cm-name">{t("chiefMinisterName")}</span>
              <span className="DhenkanalNavbarPage-cm-title">{t("chiefMinisterTitle")}</span>
            </div>
            <img
              src={cmimageremovebg}
              alt={t("chiefMinisterName")}
              className="DhenkanalNavbarPage-cm-photo"
            />
          </div>
        </div>
       )}
      </div>
    </>
  );
};

export default Dhealnavbar;
